import '../App.css';
import loadingSpinner from '../imgs/loadingSpinner.gif';

var NftAttribute = (props) => {
  let tv = props.textValue[0];
  let loader;
  let tt;
  const isCause = ['WATER','EARTH','ATMOSPHERE','PEOPLE'].includes(props.textValue[0]);

  if (isCause) {
    tv += typeof props.textValue[1] !== 'undefined' ? ': ' + props.textValue[1] : ': ';
    loader = typeof props.textValue[1] !== 'undefined'
      ? ''
      : <img className="loading-spinner" src={loadingSpinner} alt="loading" />;
    tt = 'The percentage (in basis points) of all economic activity involving\nthis ImpactKey that is allocated to this cause category.\nValues range from 100\u2013250';
  } else {
    tv += typeof props.textValue[1] !== 'undefined' ? ': ' + props.textValue[1] : '';
    tt = 'TVR (Total Value Raised) \u2014 the total USD value directed to\ncharity through this ImpactKey (sum of all cause categories)';
  }

  return (
    <span title={tt} className="nft-attribute">
      {tv}{loader}
    </span>
  );
};

export default NftAttribute;
